var map = {
	"./absent-icon.svg": "672f",
	"./arrowLeft-disable.svg": "8fe5",
	"./arrowLeft.svg": "8e7e",
	"./arrowRight-disable.svg": "1a40",
	"./arrowRight.svg": "3a02",
	"./attendance-cap.svg": "d0d5",
	"./column-sort.svg": "8926",
	"./kebab.svg": "8c03",
	"./present.svg": "a61b",
	"./scholarcap.svg": "dc5f",
	"./scholars.svg": "560a",
	"./settings.svg": "d602",
	"./sort-arrow-icon.svg": "a9a1",
	"./undo-icon.svg": "b8ff",
	"./vector-black.svg": "d875",
	"./vector.svg": "86a4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9442";